export function getTotalPrice(basePrice: number, quantity?: number) {
	return basePrice * (quantity ?? 1);
}
